<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader">
                        <h2 id="titleHeight">{{checkModuleIndex('WINL', 'R', constAccessType.view, '', -1)}}  {{this.getLanguage['WLRPT']['WLBP']}}</h2>
                    </div>
                    <div class="searchForm">
                        <div class="searchBox">
                            <div class="searchCol" v-if="!hideBrand">
                                <span class="searchLabel">{{this.getLanguage['GL']['AGT']}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="true"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput v-if="searchUserId == null" size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY')"
                                                    @change="DateTimeChange('SD',$event)" />
                                            <CInput v-else size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput v-if="searchUserId == null" size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY')"
                                                    @change="DateTimeChange('ED',$event)" />
                                            <CInput v-else size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            :cacheOptions="false"
                                            @input="setReportType"
                                            v-model="searchUserId" />
                            </div>
                            <div class="searchCol" v-if="searchUserId != null">
                                <span class="searchLabel">{{this.getLanguage['WLRPT']['WLT']}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddWinLossTypeList"
                                            :auto-load-root-options="true"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('WLRPT.WLT')"
                                            v-model="searchWinLossType" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MT"]["MT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_userType"
                                            :placeholder="this.utilGetDDLanguage('MT.MT')"
                                            v-model="searchIsTester" />
                            </div>
                            <!--Filter for AFB1188 SPORTS only-->
                            <div class='searchCol' v-if="searchGameProviderId==4">
                                <span class='searchLabel'>{{this.getLanguage['BETRPT']['BI']}} :</span>
                                <CInput v-model="searchBetId" size="sm" />
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage['BTN']['SR']}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <!-- <div class='table-wrapper' v-if="reportType == 'summary'"> -->
            <!-- Report Summary By Provider -->
            <!--<div class='table-wrapper'  v-if="reportType == 'summary'">-->
            <div class="table-wrapper color-danger" v-if="searchGameProviderId != null && searchGameProviderId.includes(55)">
                <div class="table-header d-flex text-danger">{{this.getLanguage["BETRPT"]["PKVD"]}}</div>
            </div>

            <div class='table-wrapper with_page' v-if="reportType != 'MemberSummary'">
                <header class="table-header d-flex">
                    <div v-if="searchUserId == null">
                        <strong>{{ this.getLanguage["WLRPT"]["WLRSH"] }}</strong>
                        <div class="custom-tooltip">
                            <i class="fa fa-question-circle"></i>
                            <span class="custom-tooltiptext" style="background-color: black;color: white;text-align: left;">
                                <span style="white-space: pre-line;">{{ this.getLanguage["WLRPT"]["WLRSHD"] }}</span>
                            </span>
                        </div>
                    </div>
                    <!--<div v-if="arr_summary_reportList.length != 0 && searchGameProviderId != null">
                        <span>{{ getSummaryHeader(this.getLanguage["WLRPT"]["WLRSMH"]) }}</span>
                    </div>-->
                    <div class="pageBtn ml-auto">
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper scrollHide">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th v-if="!hideBrand">{{this.getLanguage['GL']['AGT']}}<i @click="setSortSummaryTable('AGN')" :class="setSummarySortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['CI']}}<i @click="setSortSummaryTable('ISOC')" :class="setSummarySortLogo('ISOC')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['MEM']['U']}}<i @click="setSortSummaryTable('U')" :class="setSummarySortLogo('U')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage['BETRPT']['BC']}}<i @click="setSortSummaryTable('BC')" :class="setSummarySortLogo('BC')" class="sortlogo"></i></th>
                                <th v-if="repoerIsCrypto">{{this.getLanguage['CYT']['BCBA']}}</th>
                                <th v-if="repoerIsCrypto">{{this.getLanguage['CYT']['BCWLA']}}</th>
                                <th class="tableCtnRight">{{this.getLanguage['BETRPT']['BA']}}<i @click="setSortSummaryTable('BA')" :class="setSummarySortLogo('BA')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage['BETRPT']['TA']}}<i @click="setSortSummaryTable('TA')" :class="setSummarySortLogo('TA')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage['BETRPT']['WL']}}<i @click="setSortSummaryTable('WLA')" :class="setSummarySortLogo('WLA')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['PWL']}}</font>
                                </th>
                                <th class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['WWL']}}<i @click="setSortSummaryTable('WWL')" :class="setSummarySortLogo('WWL')" class="sortlogo"></i></font>
                                </th>
                                <th v-if="getUserInfo.AT == 0" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['SAWL']}}<i @click="setSortSummaryTable('SAWL')" :class="setSummarySortLogo('SAWL')" class="sortlogo"></i></font>
                                </th>
                                <th v-if="getUserInfo.AT <= 1" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['MAWL']}}<i @click="setSortSummaryTable('MAWL')" :class="setSummarySortLogo('MAWL')" class="sortlogo"></i></font>
                                </th>
                                <th v-if="getUserInfo.AT <= 2" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['AWL']}}<i @click="setSortSummaryTable('AWL')" :class="setSummarySortLogo('AWL')" class="sortlogo"></i></font>
                                </th>
                                <th v-show="withWE1POKER()" class="tableCtnRight">
                                    {{this.getLanguage['WLRPT_WE1']['LTP']}}
                                    <div class="custom-tooltip">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="custom-tooltiptext" style="background-color: black;color: white;text-align: left;bottom: -40px;">
                                            <span style="white-space: pre-line;">{{this.getLanguage["WLBMRPT"]["LTPD"]}}</span>
                                        </span>
                                    </div>
                                </th>
                                <th class="tableCtnRight">
                                    <span class="grid-line">{{this.getLanguage['WLRPT']['S']}}</span>
                                    <span class="grid-line">{{ this.shareIndicator }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_summary_reportList.length == 0 && searchGameProviderId == null">{{this.getLanguage['GL']['PSGP']}}</td>
                        <td colspan="100%" v-else-if="arr_summary_reportList.length == 0 && searchGameProviderId != null">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_summary_reportList">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="!hideBrand">{{ data.AGN }}</td>
                            <td>{{ data.ISOC }}</td>
                            <td>
                                <a href="#" @click="openMemberWinLossDetail(data)">
                                    <div class="custom-tooltip">
                                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                        <span class="custom-tooltiptext">{{ getLanguage['WLRPT']['VD'] }}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="data.TW == 0">
                                        <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                    </div>
                                </a>
                            </td>
                            <td class="tableCtnRight">{{ formatNumber(data.BC, 0) }}</td>
                            <td v-if="repoerIsCrypto" class="tableCtnRight">
                                <font v-if="withWE1POKER()">{{ toFourDecimal(data.BCBA) }}</font>
                                <font v-else>{{ formatNumber(data.BCBA, 2, data.ISOC, false) }}</font>
                            </td>
                            <td v-if="repoerIsCrypto" :class="CheckWinLoss(data.BCWLA,2,data.BCWLA)" class="tableCtnRight">
                                <font v-if="withWE1POKER()">{{ toFourDecimal(data.BCWLA) }}</font>
                                <font v-else>{{ formatNumber(data.BCWLA, 2, data.ISOC, false) }}</font>
                            </td>
                            <td class="tableCtnRight">
                                <font v-if="withWE1POKER()">{{ toFourDecimal(data.BA) }}</font>
                                <font v-else>{{ formatNumber(data.BA, 2, data.ISOC, false) }}</font>
                            </td>
                            <td :class="CheckWinLoss(data.WLA,2,data.TA)" class="tableCtnRight">{{ formatNumber(data.TA, 2, data.ISOC, false) }}</td>
                            <td :class="CheckWinLoss(data.WLA,2,data.WLA)" class="tableCtnRight">
                                <font v-if="withWE1POKER()">{{ toFourDecimal(data.WLA) }}</font>
                                <font v-else>{{ formatNumber(data.WLA, 2, data.ISOC, false) }}</font>
                            </td>
                            <td :class="CheckWinLoss(data.WLA,2,data.PWL)" class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00</span>
                                <span v-else>
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.PWL) }}</font>
                                    <font v-else>{{ formatNumber(data.PWL, 2, data.ISOC, false) }}</font>
                                </span>
                            </td>
                            <td :class="CheckWinLoss(data.WLA,2,data.WWL)" class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00</span>
                                <span v-else>
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.WWL) }}</font>
                                    <font v-else>{{ formatNumber(data.WWL, 2, data.ISOC, false) }}</font>
                                </span>
                            </td>
                            <td v-if="getUserInfo.AT == 0" :class="CheckWinLoss(data.WLA,2,data.SAWL)" class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00</span>
                                <span v-else>
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.SAWL) }}</font>
                                    <font v-else>{{ formatNumber(data.SAWL, 2, data.ISOC, false) }}</font>
                                </span>
                            </td>
                            <td v-if="getUserInfo.AT <= 1" :class="CheckWinLoss(data.WLA,2,data.MAWL)" class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00</span>
                                <span v-else>
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.MAWL) }}</font>
                                    <font v-else>{{ formatNumber(data.MAWL, 2, data.ISOC, false) }}</font>
                                </span>
                            </td>
                            <td v-if="getUserInfo.AT <= 2" :class="CheckWinLoss(data.WLA,2,data.AWL)" class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00</span>
                                <span v-else>
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.AWL) }}</font>
                                    <font v-else>{{ formatNumber(data.AWL, 2, data.ISOC, false) }}</font>
                                </span>
                            </td>
                            <td v-show="withWE1POKER()" class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00</span>
                                <span v-else :class="getWe1LastTotalPayment(data, true)">
                                    {{ getWe1LastTotalPayment(data) }}
                                </span>
                            </td>
                            <td class="tableCtnRight">
                                <span v-if="searchGameProviderId != null && searchGameProviderId == 55">0.00/0.00/0.00/0.00/0.00</span>
                                <span v-else>
                                    {{ formatPT(data) }}
                                </span>

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Player All Provider Report -->
            <div class='table-wrapper' v-if="reportType == 'MemberSummary'">
                <header class="table-header">
                    <div>
                        <strong>{{this.memberName}} {{this.getLanguage['WLRPT']['WLR']}} </strong>
                        <small>({{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}})</small>
                    </div>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <colgroup>
                            <col style="width:50px;"> <!-- No -->
                            <col style="width:80px;" v-if="!hideBrand"> <!-- Brands -->
                            <col style="width:80px;"> <!-- Currency -->
                            <col style="width:175px;"> <!-- Username -->
                            <col style="width:80px"> <!-- Provider -->
                            <col style="width:80px;"> <!-- Bet Id -->
                            <col style="width:160px;" v-if="gameNameColspan() == 2"> <!-- result -->
                            <col style="width:80px;"> <!-- Balance Before -->
                            <col v-if="repoerIsCrypto" style="width:80px;"> --<!-- Before Convert Bet Amount -->
                            <col v-if="repoerIsCrypto" style="width:80px;"> --<!-- Before Convert WL Amount -->
                            <col style="width:80px;"> <!-- Bet Amount -->
                            <col style="width:80px;"> <!-- Bet Time -->
                            <col style="width:80px;"> <!-- End Time -->
                            <col style="width:80px;"> <!-- Turnover -->
                            <col style="width:80px;"> <!-- Win/Lose -->
                            <col style="width:80px;"> <!-- Bonus -->
                            <col v-if="withBonus()" style="width:80px;"> <!-- Jackpot -->
                            <col v-if="withJackpot()" style="width:80px;"> <!-- Provider W/L -->
                            <col style="width:80px;"> <!-- House W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT == 0"> <!-- Senior Agent W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT <= 1"> <!-- Master Agent W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT <= 2"> <!-- Agent W/L -->
                            <col style="width:80px;"> <!-- Share -->
                            <col style="width:80px;"> <!-- IP -->

                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th v-if="!hideBrand">
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['CI']}}
                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')"></i>
                                </th>
                                <th :colspan="gameNameColspan()">
                                    {{this.getLanguage['PM']['GPROV']}}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BI']}}
                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')"></i>
                                </th>
                                <th :colspan="gameNameColspan()">
                                    {{this.getLanguage['BETRPT']['G']}}
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BB']}}
                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')"></i>
                                </th>
                                <th v-if="repoerIsCrypto">{{this.getLanguage['CYT']['BCBA']}}</th>
                                <th v-if="repoerIsCrypto">{{this.getLanguage['CYT']['BCWLA']}}</th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BA']}}
                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BT']}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['ET']}}
                                    <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['TO']}}
                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['WL']}}
                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')"></i>
                                </th>
                                <th v-if="withBonus()">{{this.getLanguage['WLRPT']['BN']}}</th>
                                <th v-if="withJackpot()">{{this.getLanguage['WLRPT']['JP']}}</th>
                                <th>
                                    {{this.getLanguage['WLRPT']['PWL']}}
                                </th>
                                <th>
                                    {{this.getLanguage['WLRPT']['WWL']}}
                                    <i @click="setSortTable('WWL')" :class="setSortLogo('WWL')"></i>
                                </th>
                                <th v-if="getUserInfo.AT == 0">
                                    {{this.getLanguage['WLRPT']['SAWL']}}
                                    <i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')"></i>
                                </th>
                                <th v-if="getUserInfo.AT <= 1">
                                    {{this.getLanguage['WLRPT']['MAWL']}}
                                    <i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')"></i>
                                </th>
                                <th v-if="getUserInfo.AT <= 2">
                                    {{this.getLanguage['WLRPT']['AWL']}}
                                    <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')"></i>
                                </th>
                                <th class="tableCtnRight">
                                    <span class="grid-line">{{this.getLanguage['WLRPT']['S']}}</span>
                                    <span class="grid-line">{{ this.shareIndicator }}</span>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['IP']}}
                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_provider_reportList == null || arr_provider_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_provider_reportList">
                            <tr :class="data.bool_showDetails? 'bd-selected kema-eft':' kema-eft'">
                                <td>{{ CountItem(index+1) }}</td>
                                <td v-if="!hideBrand">{{ data.AGN }}</td>
                                <td>{{ data.ISOC }}</td>
                                <td class='kema-eft' @click="CheckingMember(data.AGI,data.MI)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </td>
                                <td :colspan="gameNameColspan()"><a href="#" @click="getProviderReport(data)">{{ getProvName(data.GPN) }}</a></td>
                                <td>{{ data.TI }}</td>
                                <!--<td :colspan="gameNameColspan()">{{ getGN(data.GPN, data.GN) }}</td>-->
                                <td :colspan="gameNameColspan()">{{ getGN(data.GPN, data.GN) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.TBB, 2, data.ISOC, false) }}</td>
                                <td v-if="repoerIsCrypto" class="tableCtnRight">{{ formatNumber(data.BCBA, 2, data.ISOC, false) }}</td>
                                <td v-if="repoerIsCrypto" :class="CheckWinLoss(data.BCWLA,data.RS,data.BCWLA)" class="tableCtnRight">{{ formatNumber(data.BCWLA, 2, data.ISOC, false) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(data.BA, 2, data.ISOC, false) }}</td>
                                <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                <td>{{ generateEndTime(data.RS, data.CTS, data.RTS) }}</td>
                                <td class="tableCtnRight">{{ formatNumber(displayGameResult(data.TA, data.RS), 2, data.ISOC, false) }}</td>
                                <td :class="CheckWinLoss(data.WLA,data.RS,data.WLA)" class="tableCtnRight">{{ formatNumber(displayGameResult(data.WLA, data.RS), 2, data.ISOC, false) }}</td>
                                <td :class="data.B >= 0? 'positive-number': 'negative-number'" v-if="withBonus()" class="tableCtnRight">{{ formatNumber(data.B, 2, data.ISOC, false) }}</td>
                                <td :class="CheckWinLoss(data.WLA,data.RS,data.J)" v-if="withJackpot()" class="tableCtnRight">{{ formatNumber(data.J, 2, data.ISOC, false) }}</td>
                                <td :class="CheckWinLoss(data.WLA,data.RS,data.PWL)" class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00</span>
                                    <span v-else>{{ formatNumber(displayGameResult(data.PWL, data.RS), 2, data.ISOC, false) }}</span>
                                </td>
                                <td :class="CheckWinLoss(data.WLA,data.RS,data.WWL)" class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00</span>
                                    <span v-else>{{ formatNumber(displayGameResult(data.WWL, data.RS), 2, data.ISOC, false) }}</span>
                                </td>
                                <td v-if="getUserInfo.AT == 0" :class="CheckWinLoss(data.WLA,data.RS,data.SAWL)" class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00</span>
                                    <span v-else>{{ formatNumber(displayGameResult(data.SAWL, data.RS), 2, data.ISOC, false) }}</span>
                                </td>
                                <td v-if="getUserInfo.AT <= 1" :class="CheckWinLoss(data.WLA,data.RS,data.MAWL)" class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00</span>
                                    <span v-else>{{ formatNumber(displayGameResult(data.MAWL, data.RS), 2, data.ISOC, false) }}</span>
                                </td>
                                <td v-if="getUserInfo.AT <= 2" :class="CheckWinLoss(data.WLA,data.RS,data.AWL)" class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00</span>
                                    <span v-else>{{ formatNumber(displayGameResult(data.AWL, data.RS), 2, data.ISOC, false) }}</span>
                                </td>
                                <td class="tableCtnRight">
                                    <span v-if="data.GPI == 55">0.00/0.00/0.00/0.00/0.00</span>
                                    <span v-else>{{ formatPT(data) }}</span>
                                </td>
                                <td>{{ data.MIP }}</td>
                            </tr>


                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Player All Provider Report End -->

            <div class='table-wrapper' v-if="reportType != 'summary' && reportType != 'MemberSummary' && reportType != null">
                <header class="table-header">
                    <div>
                        <strong>{{this.getProviderName()}} {{this.getLanguage['WLRPT']['WLR']}} </strong>
                        <small>({{this.getLanguage['WLRPT']['LRO']}} : {{this.DataLastUpdatedTS}})</small>
                        <div v-if="(
                         reportType=='YGGDRASIL' ||
                         reportType=='YGGDRASIL_E_CASINO' ||
                         reportType=='PNG_SLOT' ||
                         reportType=='AUX_SLOT' ||
                         reportType=='GHG_SLOT' ||
                         reportType=='NLC_SLOT' ||
                         reportType=='RELAX_SLOT' ||
                         reportType=='RELAX_E_CASINO' ||
                         reportType=='ATA_EVOPLAY')" class="custom-tooltip">
                            <i class="fa fa-question-circle"></i>
                            <span class="custom-tooltiptext" style="background-color: black;color: white;text-align: left;">
                                <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["YGGIS"]}}</span>
                            </span>
                        </div>
                    </div>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>


                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <colgroup>
                            <col style="width:50px;"> <!-- Brands -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Brands -->
                            <col style="width:175px;"> <!-- Username -->
                            <col style="width:80px;"> <!-- Bet Id -->
                            <col style="width:80px;"> <!-- Game -->
                            <col style="width:160px;" v-if="gameNameColspan() == 2">
                            <col style="width:80px;"> <!-- Result -->
                            <col style="width:160px;" v-if="gameResultColspan() == 2">
                            <col style="width:80px;"> <!-- Balance Before -->
                            <col style="width:80px;" v-if="repoerIsCrypto"> <!-- Before Convert Bet Amount -->
                            <col style="width:80px;" v-if="repoerIsCrypto"> <!-- Before Convert WL Amount -->
                            <col style="width:80px;"> <!-- Bet Amount -->
                            <col style="width:80px;"> <!-- Bet Time -->
                            <col style="width:80px;"> <!-- End Time -->
                            <col style="width:80px;"> <!-- Currency -->
                            <col style="width:80px;" v-if="withWE1POKER() && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Exchange Rate -->
                            <col style="width:80px;" v-if="withWE1POKER() && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Turnover -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Win/Lose -->

                            <col style="width:80px;" v-if="withBonus()"> <!-- Bonus -->
                            <col style="width:80px;" v-if="withJackpot()"> <!-- Jackpot -->

                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Provider W/L -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- House W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT == 0 && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Senior Agent W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT <= 1 && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Master Agent W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT <= 2 && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Agent W/L -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Share -->
                            <col style="width:80px;"> <!-- IP -->
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BI']}}
                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')"></i>
                                </th>
                                <th :colspan="gameNameColspan()">
                                    {{this.getLanguage['BETRPT']['G']}}
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')"></i>
                                </th>
                                <th :colspan="gameResultColspan()">
                                    {{this.getLanguage['WLRPT']['R']}}
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BB']}}
                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')"></i>
                                </th>
                                <th v-if="repoerIsCrypto" class="tableCtnRight">{{this.getLanguage['CYT']['BCBA']}}</th>
                                <th v-if="repoerIsCrypto" class="tableCtnRight">{{this.getLanguage['CYT']['BCWLA']}}</th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['BETRPT']['BA']}}
                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BT']}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['ET']}}
                                    <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['CI']}}
                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')"></i>
                                </th>
                                <th class="tableCtnRight" v-if="withWE1POKER() && searchGameProviderId != null && searchGameProviderId != 55">
                                    {{this.getLanguage['WLBP']['CR']}}
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['MEM']['TO']}}</font>
                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')"></i>
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    {{this.getLanguage['BETRPT']['WL']}}
                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')"></i>
                                </th>

                                <th v-if="withBonus()">{{this.getLanguage['WLRPT']['BN']}}</th>
                                <th v-if="withJackpot()">{{this.getLanguage['WLRPT']['JP']}}</th>

                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['PWL']}}</font>
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['WWL']}}<i @click="setSortTable('WWL')" :class="setSortLogo('WWL')"></i></font>
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT == 0 && searchGameProviderId != null && searchGameProviderId != 55">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['SAWL']}}<i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')"></i></font>
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 1 && searchGameProviderId != null && searchGameProviderId != 55">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['MAWL']}}<i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')"></i></font>

                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 2 && searchGameProviderId != null && searchGameProviderId != 55">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['AWL']}}<i @click="setSortTable('AWL')" :class="setSortLogo('AWL')"></i></font>
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <span class="grid-line">{{this.getLanguage['WLRPT']['S']}}</span>
                                    <span class="grid-line">{{ this.shareIndicator }}</span>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['IP']}}
                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')"></i>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <colgroup>
                            <col style="width:50px;"> <!-- Brands -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Brands -->
                            <col style="width:175px;"> <!-- Username -->
                            <col style="width:80px;"> <!-- Bet Id -->
                            <col style="width:80px;"> <!-- Game -->
                            <col style="width:160px;" v-if="gameNameColspan() == 2">
                            <col style="width:80px;"> <!-- Result -->
                            <col style="width:160px;" v-if="gameResultColspan() == 2">
                            <col style="width:80px;"> <!-- Balance Before -->
                            <col style="width:80px;" v-if="repoerIsCrypto"> <!-- Before Convert Bet Amount -->
                            <col style="width:80px;" v-if="repoerIsCrypto"> <!-- Before Convert WL Amount -->
                            <col style="width:80px;"> <!-- Bet Amount -->
                            <col style="width:80px;"> <!-- Bet Time -->
                            <col style="width:80px;"> <!-- End Time -->
                            <col style="width:80px;"> <!-- Currency -->
                            <col style="width:80px;" v-if="withWE1POKER() && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Exchange Rate -->
                            <col style="width:80px;" v-if="withWE1POKER() && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Turnover -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Win/Lose -->

                            <col style="width:80px;" v-if="withBonus()"> <!-- Bonus -->
                            <col style="width:80px;" v-if="withJackpot()"> <!-- Jackpot -->

                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Provider W/L -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- House W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT == 0 && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Senior Agent W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT <= 1 && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Master Agent W/L -->
                            <col style="width:80px;" v-if="getUserInfo.AT <= 2 && searchGameProviderId != null && searchGameProviderId != 55"> <!-- Agent W/L -->
                            <col style="width:80px;" v-if="searchGameProviderId != null && searchGameProviderId != 55"> <!-- Share -->
                            <col style="width:80px;"> <!-- IP -->
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BI']}}
                                    <i @click="setSortTable('TI')" :class="setSortLogo('TI')"></i>
                                </th>
                                <th :colspan="gameNameColspan()">
                                    {{this.getLanguage['BETRPT']['G']}}
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')"></i>
                                </th>
                                <th :colspan="gameResultColspan()">
                                    {{this.getLanguage['WLRPT']['R']}}
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BB']}}
                                    <i @click="setSortTable('BB')" :class="setSortLogo('BB')"></i>
                                </th>
                                <th v-if="repoerIsCrypto" class="tableCtnRight">{{this.getLanguage['CYT']['BCBA']}}</th>
                                <th v-if="repoerIsCrypto" class="tableCtnRight">{{this.getLanguage['CYT']['BCWLA']}}</th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['BETRPT']['BA']}}
                                    <i @click="setSortTable('BA')" :class="setSortLogo('BA')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['BT']}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['ET']}}
                                    <i @click="setSortTable('RTS')" :class="setSortLogo('RTS')"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['CI']}}
                                    <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')"></i>
                                </th>
                                <th class="tableCtnRight" v-if="withWE1POKER() && searchGameProviderId != null && searchGameProviderId != 55">
                                    {{this.getLanguage['WLBP']['CR']}}
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['MEM']['TO']}}</font>
                                    <i @click="setSortTable('TA')" :class="setSortLogo('TA')"></i>
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    {{this.getLanguage['BETRPT']['WL']}}
                                    <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')"></i>
                                </th>

                                <th v-if="withBonus()">{{this.getLanguage['WLRPT']['BN']}}</th>
                                <th v-if="withJackpot()">{{this.getLanguage['WLRPT']['JP']}}</th>

                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['PWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['PWL']}}</font>
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['WWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['WWL']}}<i @click="setSortTable('WWL')" :class="setSortLogo('WWL')"></i></font>
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT == 0 && searchGameProviderId != null && searchGameProviderId != 55">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['SAWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['SAWL']}}<i @click="setSortTable('SAWL')" :class="setSortLogo('SAWL')"></i></font>
                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 1 && searchGameProviderId != null && searchGameProviderId != 55">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['MAWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['MAWL']}}<i @click="setSortTable('MAWL')" :class="setSortLogo('MAWL')"></i></font>

                                </th>
                                <th class="tableCtnRight" v-if="getUserInfo.AT <= 2 && searchGameProviderId != null && searchGameProviderId != 55">
                                    <font v-if="withWE1POKER()">{{this.getLanguage['WLRPT_WE1']['AWL_RAKE']}}</font>
                                    <font v-else>{{this.getLanguage['WLRPT']['AWL']}}<i @click="setSortTable('AWL')" :class="setSortLogo('AWL')"></i></font>
                                </th>
                                <th v-if="searchGameProviderId != null && searchGameProviderId != 55" class="tableCtnRight">
                                    <span class="grid-line">{{this.getLanguage['WLRPT']['S']}}</span>
                                    <span class="grid-line">{{ this.shareIndicator }}</span>
                                </th>
                                <th>
                                    {{this.getLanguage['BETRPT']['IP']}}
                                    <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_provider_reportList == null || arr_provider_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_provider_reportList">
                            <tr @click="clickList(data,index,data.RURL)" :class="data.bool_showDetails? 'bd-selected kema-eft pointer':' kema-eft pointer'">
                                <!--No-->
                                <td>{{ CountItem(index+1) }}</td>
                                <!--Brand-->
                                <td>{{ data.AGN }}</td>
                                <!--UserID-->
                                <td class='kema-eft' @click="CheckingMember(data.AGI,data.MI)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="arr_summary_reportList!=null && arr_summary_reportList.length > 0 && arr_summary_reportList[0].TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </td>
                                <!--Bet ID-->
                                <td>{{ data.TI }}</td>
                                <!--Game-->
                                <td :colspan="gameNameColspan()" v-html="getGameName(data.GN, data)"></td>
                                <!--Result-->
                                <td @click="gameResultOnClick(data)" :colspan="gameResultColspan()" v-html="renderGameResult(data.GR, data)"></td>
                                <!--Balance Before-->
                                <td class="tableCtnRight">{{ formatNumber(data.TBB, 2, data.ISOC, false) }}</td>
                                <!-- Before Convert Bet Amount -->
                                <td v-if="repoerIsCrypto" class="tableCtnRight">{{ formatNumber(data.BCBA, 2, data.ISOC, false) }}</td>
                                <!-- Before Convert WL Amount  -->
                                <td v-if="repoerIsCrypto" :class="CheckWinLoss(data.BCWLA,data.RS,data.BCWLA)" class="tableCtnRight">{{ formatNumber(data.BCWLA, 2, data.ISOC, false) }}</td>
                                <!--Bet Amount-->
                                <td class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.BA) }}</font>
                                    <font v-else>{{ formatNumber(data.BA, 2, data.ISOC, false) }}</font>
                                    <div v-if="reportType=='AFB1188' && data.OBA!=''" v-html="data.OBA" class="oddsinfo"></div>
                                </td>
                                <!--Bet Time (GMT+08)-->
                                <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</td>
                                <!--End Time (GMT+08)-->
                                <td>{{ generateEndTime(data.RS, data.CTS, data.RTS) }}</td>
                                <!--Currency-->
                                <td>{{ data.ISOC }}</td>
                                <!--Currency Rate-->
                                <td v-if="withWE1POKER() && data.GPI != 55" class="tableCtnRight">
                                    {{ displayExchangeRate(data.CI) }}
                                </td>
                                <!--Rate-->
                                <td v-if="data.GPI != 55" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.TA, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.TA, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <!--Member W/L-->
                                <td v-if="data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.WLA)" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.WLA, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.WLA, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <td :class="data.B >= 0? 'positive-number': 'negative-number'" v-if="withBonus()" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(data.B) }}</font>
                                    <font v-else>{{ formatNumber(data.B, 2, data.ISOC, false) }}</font>
                                </td>
                                <td :class="CheckWinLoss(data.WLA,data.RS,data.J)" v-if="withJackpot()" class="tableCtnRight">{{ formatNumber(data.J, 2, data.ISOC, false) }}</td>
                                <!--Provider Rake-->
                                <td v-if="data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.PWL)" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.PWL, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.PWL, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <!--House Rake-->
                                <td v-if="data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.WWL)" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.WWL, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.WWL, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <!--SA Rake-->
                                <td v-if="getUserInfo.AT == 0 && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.SAWL)" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.SAWL, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.SAWL, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <!--MA Rake-->
                                <td v-if="getUserInfo.AT <= 1 && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.MAWL)" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.MAWL, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.MAWL, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <!--AG Rake-->
                                <td v-if="getUserInfo.AT <= 2 && data.GPI != 55" :class="CheckWinLoss(data.WLA,data.RS,data.AWL)" class="tableCtnRight">
                                    <font v-if="withWE1POKER()">{{ toFourDecimal(displayGameResult(data.AWL, data.RS)) }}</font>
                                    <font v-else>{{ formatNumber(displayGameResult(data.AWL, data.RS), 2, data.ISOC, false) }}</font>
                                </td>
                                <td v-if="data.GPI != 55" class="tableCtnRight">{{ formatPT(data) }}</td>
                                <!--IP-->
                                <td>{{ data.MIP }}</td>
                            </tr>

                            <!-- N2 Details -->
                            <template v-if="reportType=='N2' && data.bool_showDetails">
                                <template v-if="data.DT != 1 && data.DT != 3">
                                    <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{{ cdata.BID}}</td>
                                        <td colspan="2"></td>
                                        <td colspan="2" v-html="cdata.BD"></td>
                                        <td></td>
                                        <!-- Before Convert Bet Amount -->
                                        <td v-if="repoerIsCrypto" class="tableCtnRight">{{ formatNumber(data.BCBA, 2, data.ISOC, false) }}</td>
                                        <!-- Before Convert WL Amount-->
                                        <td v-if="repoerIsCrypto" :class="data.BCWLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.BCWLA, 2, data.ISOC, false) }}</td>
                                        <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{{ data.ISOC }}</td>
                                        <td colspan="2" :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                        <td></td>
                                        <td></td>
                                        <td v-if="getUserInfo.AT == 0"></td>
                                        <td v-if="getUserInfo.AT <= 1"></td>
                                        <td v-if="getUserInfo.AT <= 2"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </template>
                                <template v-if="data.DT == 1">
                                    <tr class="bd-head-bg n2-subitem">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{{getLanguage['BETRPT']['BI']}}</td>
                                        <td width="40">{{getLanguage['WLRPT']['ST']}}</td>
                                        <td width="40">{{getLanguage['WLRPT']['HD']}}</td>
                                        <td>{{getLanguage['WLRPT']['CAT']}}</td>
                                        <td>{{getLanguage['WLRPT']['CT']}}</td>
                                        <td>{{getLanguage['WLRPT']['DH']}}</td>
                                        <td>{{getLanguage['BETRPT']['BA']}}</td>
                                        <td></td>
                                        <td>{{getLanguage['MEM']['CI']}}</td>
                                        <td colspan="2">{{getLanguage['BETRPT']['WL']}}</td>
                                        <td></td>
                                        <td></td>
                                        <td v-if="getUserInfo.AT == 0"></td>
                                        <td v-if="getUserInfo.AT <= 1"></td>
                                        <td v-if="getUserInfo.AT <= 2"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{{cdata.BID}}</td>
                                        <td>{{cdata.CBD.S}}</td>
                                        <td>{{cdata.CBD.H}}</td>
                                        <td>{{cdata.CBD.C}}</td>
                                        <td v-html="cdata.CBD.CT"></td>
                                        <td v-if="cindex == 0" :rowspan="data.BTDESCR.length" v-html="cdata.CBD.DH"></td>
                                        <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                        <td></td>
                                        <td>{{ data.ISOC }}</td>
                                        <td colspan="2" :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                        <td></td>
                                        <td></td>
                                        <td v-if="getUserInfo.AT == 0"></td>
                                        <td v-if="getUserInfo.AT <= 1"></td>
                                        <td v-if="getUserInfo.AT <= 2"></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </template>
                                <template v-if="data.DT == 3">
                                    <template v-for="(cdata, cindex) in data.BTDESCR">
                                        <tr v-if="cdata.TYPE == 1" class="bd-bg n2-subitem">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td colspan="2">{{cdata.CBD.S}}</td>
                                            <td colspan="2" v-html="cdata.CBD.CD"></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td colspan="2"></td>
                                            <td></td>
                                            <td></td>
                                            <td v-if="getUserInfo.AT == 0"></td>
                                            <td v-if="getUserInfo.AT <= 1"></td>
                                            <td v-if="getUserInfo.AT <= 2"></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr v-if="cdata.TYPE == 0" class="bd-head-bg n2-subitem">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td colspan="4">{{getLanguage['WLRPT']['CAT']}}</td>
                                            <td></td>
                                            <td colspan="2" class="tableCtnRight">{{getLanguage['BETRPT']['BA']}}</td>
                                            <td></td>
                                            <td colspan="2" class="tableCtnRight">{{getLanguage['BETRPT']['WL']}}</td>
                                            <td></td>
                                            <td></td>
                                            <td v-if="getUserInfo.AT == 0"></td>
                                            <td v-if="getUserInfo.AT <= 1"></td>
                                            <td v-if="getUserInfo.AT <= 2"></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr v-if="cdata.TYPE == 2" class="bd-bg n2-subitem">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td colspan="4">{{ cdata.BD }}</td>
                                            <td></td>
                                            <td colspan="2" class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                            <td></td>
                                            <td colspan="2" :class="cdata.WLA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                            <td></td>
                                            <td></td>
                                            <td v-if="getUserInfo.AT == 0"></td>
                                            <td v-if="getUserInfo.AT <= 1"></td>
                                            <td v-if="getUserInfo.AT <= 2"></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                            <!-- AFB1188 Details -->
                            <template v-if="reportType=='AFB1188' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg afb1188-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2" v-html="getGameName(cdata.GD)"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2" v-html="renderAFBWL(cdata.CBD.res)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <!--<td></td>-->
                                </tr>
                            </template>
                            <!-- SBO SPORTS Details -->
                            <template v-if="reportType=='SBO_SPORTSBOOK' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg afb1188-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2" v-html="getGameName(cdata.GD)"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="1" v-html="renderSBOWL(cdata.CBD)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- TFG_ESPORTS Details -->
                            <template v-if="reportType=='TFG_ESPORTS' && data.bool_showDetails && data.DT == 1">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg tfg-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2" v-html="getGameName(cdata.GD)"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2">{{ cdata.CBD }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <!--<td></td>-->
                                </tr>
                            </template>
                            <!-- PGSOFT Details -->
                            <template v-if="reportType=='PGSOFT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.PGSOFTCHILD" :class="bd-bg">
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td>{{ cdata.PTI }}</td>
                                    <td colspan="2">{{ cdata.TI }}</td>
                                    <td @click="PGgameResult(cdata.PTI,cdata.TI,cdata.GI)"><a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></td>
                                    <td colspan="6"></td>
                                    <td :class="cdata.WLA == 0? '': cdata.WLA > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                    <td :class="cdata.JP == 0? '': cdata.JP > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.JP, 2, data.ISOC, false) }}</td>
                                    <td colspan="7"></td>
                                </tr>
                            </template>
                            <!-- GD88 Details -->
                            <template v-if="reportType=='DIAMONDCLUB' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg  diamondclub-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ renderGD88WL(cdata.GD) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- CQ9 Details -->
                            <template v-if="reportType=='CQ9_CASINO' && data.bool_showDetails && data.DT == 0">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2">{{ utilGetErrorLanguage('WLRPT_CQ9.' + cdata.BD) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(data)" colspan="2" v-html="renderGameResult(data.RURL, data, true)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EVOPLAY Details -->
                            <template v-if="reportType=='EVOPLAY_CASINO' && data.bool_showDetails && data.DT == 0">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="3"></td>
                                    <td colspan="2" v-if="data.GN == 967">{{ utilGetErrorLanguage('WLRPT_EVO.' + cdata.BD) }}</td>
                                    <td colspan="2" v-if="data.GN == 748">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 745">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 751">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 946">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 1006">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 1009">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 5553">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 5669">{{ cdata.BD }}</td>
                                    <td colspan="2" v-if="data.GN == 5679">{{ cdata.BD }}</td>
                                    <td></td>
                                    <td>{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- WM Details -->
                            <template v-if="reportType=='WM' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- 93Connect Details -->
                            <template v-if="reportType=='CONNECT93' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <!--<td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>-->
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- AESEXY Details -->
                            <template v-if="reportType=='AESEXY' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- SV388 Details -->
                            <template v-if="reportType=='SV388' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- CF361 Details -->
                            <template v-if="reportType=='CF361' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2" :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- SA Details -->
                            <template v-if="reportType=='SA' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- TGA Details -->
                            <template v-if="reportType=='AFBCASINO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- LIGATOGEL Details -->
                            <template v-if="reportType=='LIGATOGEL' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"> </td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- AFB288 Details -->
                            <template v-if="reportType=='AFB288_LOTTERY' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"> </td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- DG Details -->
                            <template v-if="reportType=='DREAMGAME' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- AFB GAMING Details  SP is showing error, already had a ticket for this. --TT3210 -->
                            <template v-if="(reportType=='AFBGAMING' || reportType=='AFBGAMING_FISHING') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" :class="bd-bg">
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(cdata.TI)"><a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- LUCKY 361 Details -->
                            <template v-if="reportType=='LUCKY361_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" :class="bd-bg">
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(cdata.TI)"><a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EACASINO Details -->
                            <template v-if="reportType=='EACASINO' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2">{{ cdata.GD}}</td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- Spinomenal Slot Details -->
                            <template v-if="(reportType=='SPINOMENAL_SLOT' || reportType=='SPINOMENAL_LOTTERY') && data.bool_showDetails">
                                <tr v-if="cdata.TI != data.TI" v-for="(cdata, cindex) in data.SPINOMENALCHILD" :class="bd-bg">
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td>{{ cdata.TI}}</td>
                                    <td colspan="2"></td>
                                    <td v-if="cdata.URL!='' && cdata.URL!=null " colspan="2"> <a :href="cdata.URL" target="_blank"> {{getLanguage["WLRPT"]["VT"]}}</a></td>
                                    <td v-else colspan="2" @click="openSpinomenalDetails(cdata)"> <a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EVOLUTION Details -->
                            <template v-if="reportType=='EVOLUTION_CASINO' && data.bool_showDetails && data.DT == 0">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="3" v-html="cdata.BD"></td>
                                    <td class="tableCtnRight" v-if="data.GN == 'MegaBall00000001' && cindex == 0 || data.GN !== 'MegaBall00000001'">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td :class="cdata.WLA == 0? '': cdata.WLA > 0 ? 'positive-number': 'negative-number'" class="tableCtnRight" v-if="data.GN == 'MegaBall00000001' && cindex == 0 || data.GN !== 'MegaBall00000001'">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- WE1POKER Details -->
                            <template v-if="reportType=='WE1POKER' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2">{{ cdata.GD}}</td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- SIMPLE PLAY SLOT Details -->
                            <template v-if="reportType=='SIMPLEPLAY_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" :class="bd-bg">
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="openSimplePlayDetails(cdata)"><a href="#"> {{getLanguage["WLRPT"]["VT"]}}</a></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EBET Details -->
                            <template v-if="reportType=='EBET' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2">{{ cdata.GD}}</td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="tableCtnRight">{{ formatNumber(cdata.BA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(cdata.WLA, 2, data.ISOC, false) }}</td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EBET SLOT Details -->
                            <template v-if="reportType=='EBET_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- SIMPLE PLAY FISHING Details -->
                            <template v-if="reportType=='SIMPLEPLAY_FISHING' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="3" v-html="renderGameResult(cdata.BD, cdata)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- CG Details -->
                            <template v-if="(reportType=='CG' || reportType=='CG_FISHING' || reportType=='CG_VIRTUAL_CASINO' || reportType=='CG_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td class="tableCtnRight"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- POKERV Details this part not using (Please refer Poker V BackOffice for Detailed Report)-->
                            <template v-if="(reportType=='POKERV') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg n2-subitem">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ cdata.BID}}</td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td class="tableCtnRight"></td>
                                    <td></td>
                                    <td></td>
                                    <!--<td></td>
            <td :class="cdata.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight"></td>
            <td></td>
            <td></td>
            <td v-if="getUserInfo.AT == 0"></td>
            <td v-if="getUserInfo.AT <= 1"></td>
            <td v-if="getUserInfo.AT <= 2"></td>
            <td></td>-->
                                    <td></td>
                                </tr>
                            </template>
                            <!-- LG88 Details -->
                            <template v-if="reportType=='LG88' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="lg88RenderDetail(cdata.CBD)"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- YGGDRASIL Details -->
                            <template v-if="(reportType=='YGGDRASIL' || reportType=='YGGDRASIL_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- PNG_SLOT Details -->
                            <template v-if="reportType=='PNG_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- AUX_SLOT Details -->
                            <template v-if="reportType=='AUX_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- GHG_SLOT Details -->
                            <template v-if="reportType=='GHG_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- NLC_SLOT Details -->
                            <template v-if="reportType=='NLC_SLOT' && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- RELAX_SLOT && RELAX_E_CASINO Details -->
                            <template v-if="(reportType=='RELAX_SLOT' || reportType=='RELAX_E_CASINO') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(data)" colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- JILI Details -->
                            <template v-if="(reportType=='JILI_SLOT' || reportType=='JILI_FISHING') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(data)" colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EVORacing Details -->
                            <template v-if="(reportType=='EVO_RACING') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(data)" colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- EVORacingVR Details -->
                            <template v-if="(reportType=='EVO_RACING_VR') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(data)" colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                            <!-- ATA_EVOPLAY_SLOT Details -->
                            <template v-if="(reportType=='ATA_EVOPLAY_SLOT') && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.BTDESCR" class="bd-bg">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td @click="gameResultDetailOnClick(data)" colspan="2" v-html="cdata.BD"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td colspan="2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-if="getUserInfo.AT == 0"></td>
                                    <td v-if="getUserInfo.AT <= 1"></td>
                                    <td v-if="getUserInfo.AT <= 2"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { constWinLossType } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            Loading
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                // dropdown value
                ddAgentList: null,
                ddGameProviderList: null,
                ddWinLossTypeList: constWinLossType,
                ddMemberList: null,
                ddDefaultMemberList: null,
               // ddDefaultMemberTypeList: null,
                dd_userType: [],
                // search fields
                searchAgi: 0,
                searchAgent: null,
                searchUserId: null,
                searchUserType: null,
                searchUsername: null,
                searchGameProviderId: null,
                searchWinLossType: null,
                searchIsTester: null,
                searchBetId:null,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getMonthEndDate() },
                arr_provider_reportList: {},
                arr_summary_reportList: [],
                reportType: "summary",
                skipPageUpdate: false,
                dd_memberKey: 0,
                memberName: "",
                DataLastUpdatedTS: "-",
                shareIndicator: "",
                constAccessType: constAccessType,
                str_summary_tableSortBy: "", //(sort summary table col name)
                bool_summary_isSort: true, // summary Table Ascending Descending
                repoerIsCrypto: false,
                searchCurrency: null,
                hideBrand: false,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            setSortSummaryTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_summary_tableSortBy = SV;
                this.bool_summary_isSort = !this.bool_summary_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            setSummarySortLogo(str_TF) {
                return `cil-${this.str_summary_tableSortBy == str_TF ? (this.bool_summary_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.searchAgi = 0;
                if (value) {
                    var agentList = value.split("-");
                    this.searchAgi = agentList[agentList.length - 1];
                }
            },
            selectGameProvider(value, instanceId) {
                this.setReportType();
            },
            setReportType() {
                this.arr_provider_reportList = {};
                var previousReportType = this.reportType;
                //debugger;
                this.reportType = 'summary';
                this.showSummary = true;
                if (this.searchGameProviderId) {
                    if (this.searchUserId && this.ddGameProviderList) {
                        for (var i = 0; i < this.ddGameProviderList.length; i++) {
                            if (this.ddGameProviderList[i].id == this.searchGameProviderId) {
                                this.reportType = this.ddGameProviderList[i].RT;
                                break;
                            }
                        }
                    }
                    else {
                        this.reportType = 'summary';

                    }
                }
                else if (this.searchUserId) {
                    this.reportType = 'MemberSummary';
                    this.getMemberName();
                    this.showSummary = false;
                }

                if (this.reportType != previousReportType) {
                    this.str_tableSortBy = "";
                }
            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddGameProviderList = d.dropdownlist;
                            for (var i = 0; i < that.ddGameProviderList.length; i++) {
                                that.ddGameProviderList[i].RT = that.ddGameProviderList[i].label2;
                                that.ddGameProviderList[i].label = that.renderProviderName(that.ddGameProviderList[i].label2);
                            }

                            that.ddGameProviderList.forEach(bar => {
                                bar.value = 25 + (Math.random() * 75)
                            })
                        }
                        else {
                            that.ddGameProviderList = null;
                        }

                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            getReportList() {
                if (this.reportType != null) {
                    this.repoerIsCrypto = false;
                    this.bool_fullLoading = true;
                    var that = this;
                    var agentGId = null;

                    if (this.searchAgi > 0) {
                        agentGId = this.searchAgi;
                    }
                    if (that.reportType != "summary") {
                        var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    }
                    else {
                        var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_summary_tableSortBy, this.bool_summary_isSort);

                    }
                    var hasDefaultPath = false;

                    if (path) {
                        hasDefaultPath = true;
                    }
                    path += "&f.FW=1" ;

                    path += "&f.LC=" + this.getLangCode;

                    if (agentGId) {
                        path += "&f.AGI=" + agentGId;
                    }

                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchBetId) {
                        path += "&f.BI=" + this.searchBetId;
                    }

                    if (this.searchGameProviderId) {
                        path += "&f.GPI=" + this.searchGameProviderId;
                    }

                    if (this.searchWinLossType) {
                        path += "&f.WLT=" + this.searchWinLossType;
                    }

                    if (this.searchCreatedTS) {
                        if (this.searchCreatedTS.startDate != "") {
                            path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        }

                        if (this.searchCreatedTS.endDate != "") {
                            path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        }
                    }

                    if (this.searchIsTester) {
                        path += "&f.ITU=" + this.searchIsTester;
                    }

                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }
                    if (that.reportType == "summary") {

                        this.getDataApi(this.getReportURL() + `?${path}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.D.Items);
                                    that.int_TP = Math.max(d.D.TotalPages, 1);
                                    that.int_Total = d.D.TotalItems;
                                    that.arr_summary_reportList = d.D.Items;
                                }
                            });
                    }
                    else if (that.reportType == "MemberSummary") {
                        this.getDataApi(this.getReportURL() + `?${path}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.handlerResponse(d.Item1);
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.Item1.D.Items);
                                    that.int_TP = Math.max(d.Item1.D.TotalPages, 1);
                                    that.int_Total = d.Item1.D.TotalItems;

                                    if (d && d.D && d.Item1 && d.Item1.D.Items) {
                                        for (var i = 0; i < d.Item1.D.Items.length; i++) {
                                            d.Item1.D.Items[i].bool_showDetails = false;
                                        }
                                    }
                                    that.arr_provider_reportList = d.Item1.D.Items;
                                }
                            });
                    }
                    else {
                        //var TotalWithdraw = 0;
                        this.getDataApi("/api/reports/winloss/summary" + `?${path}`,
                            function (d, s) {
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.D.Items);
                                   // that.int_TP = Math.max(d.D.TotalPages, 1);
                                   // that.int_Total = d.D.TotalItems;
                                    that.arr_summary_reportList = d.D.Items;
                                    //if (d.D.Items.length > 0) {
                                    //    TotalWithdraw = d.D.Items[0].TW;
                                    //}                                    
                                }
                            });
                        this.getDataApi(this.getReportURL() + `?${path}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.DataLastUpdatedTS = that.getLUTS(d.D.Items);
                                    that.int_TP = Math.max(d.D.TotalPages, 1);
                                    that.int_Total = d.D.TotalItems;

                                    if (d && d.D && d.D.Items) {
                                        for (var i = 0; i < d.D.Items.length; i++) {
                                            d.D.Items[i].bool_showDetails = false;
                                         //   d.D.Items[i].TW = TotalWithdraw;
                                        }
                                    }
                                    that.arr_provider_reportList = d.D.Items;
                                }
                            });

                    }
                    // this.getDataApi(this.getReportURL() + `?${path}`,
                    //     function (d, s) {
                    //         that.bool_fullLoading = false;
                    //         if (s) {
                    //             that.int_TP = Math.max(d.D.TotalPages, 1);
                    //             that.int_Total = d.D.TotalItems;

                    //             switch (that.reportType) {
                    //                 case "N2":
                    //                 case "DIAMONDCLUB":
                    //                 case "PS":
                    //                 case "PPLAY":
                    //                 case "PGSOFT":
                    //                 case "AFB1188":
                    //                 case "CQ9":
                    //                 case "CQ9_CASINO":
                    //                 case "EVOPLAY":
                    //                 case "EVOPLAY_CASINO":
                    //                 case "BETSOFT":
                    //                 case "BETSOFT_CASINO":
                    //                 case "BETSOFT_POKER":
                    //                 case "JOKER":
                    //                 case "JOKER_CASINO":
                    //                 case "WM":
                    //                 case "TFG_ESPORTS":
                    //                     if (d && d.D && d.D.Items) {
                    //                         for (var i = 0; i < d.D.Items.length; i++) {
                    //                             d.D.Items[i].bool_showDetails = false;
                    //                         }
                    //                     }
                    //                     that.arr_provider_reportList = d.D.Items;
                    //                     break;
                    //                 case "summary":
                    //                 default:
                    //                     that.arr_summary_reportList = d.D.Items;
                    //                     break;
                    //             }
                    //         }
                    //     });

                    this.resizeTableHead();
                    for (var i = 0; i < this.arr_summary_reportList.length; i++) {
                        if (this.arr_summary_reportList[i].ICT)
                            this.repoerIsCrypto = this.arr_summary_reportList[i].ICT;
                    }
                }
                else {
                    this.showErrorMessage(null, this.getLanguage['WLRPT']['PSP'], 1000);
                }
            },
            saveToExcel() {

                if (this.reportType != null) {
                    this.bool_fullLoading = false;
                    var that = this;
                    var agentGId = null;

                    if (this.searchAgi > 0) {
                        agentGId = this.searchAgi;
                    }

                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    var hasDefaultPath = false;

                    if (path) {
                        hasDefaultPath = true;
                    }

                    if (agentGId) {
                        path += "&f.AGI=" + agentGId;
                    }

                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchBetId) {
                        path += "&f.BI=" + this.searchBetId;
                    }

                    if (this.searchGameProviderId) {
                        path += "&f.GPI=" + this.searchGameProviderId;
                    }

                    if (this.searchWinLossType) {
                        path += "&f.WLT=" + this.searchWinLossType;
                    }

                    if (this.searchIsTester) {
                        path += "&f.ITU=" + this.searchIsTester;
                    }

                    if (this.searchCurrency && this.reportType !='summary') {
                        path += "&f.CI=" + this.searchCurrency;
                    }

                    path += "&f.RT=" + this.reportType;
                    path += "&f.LC=" + this.getLangCode;

                    if (this.searchCreatedTS) {
                        if (this.searchCreatedTS.startDate != "") {
                            path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        }

                        if (this.searchCreatedTS.endDate != "") {
                            path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                        }
                    }

                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    window.open('/api/reports/newwinlossexcelv2?' + path, '_blank');
                }
                /*
                else {
                    this.showErrorMessage(null, this.getLanguage['WLRPT']['PSP'], 1000);
                }
                */
            },
            getLUTS(items) {
                if (items !=null && items.length > 0) {
                    var result = moment(items[items.length - 1].UTS).format("MMM DD, YYYY hh:mm a");
                    try {
                        //new Date(Math.max.apply(null, items.map(function(e) {
                        //    var temp = new Date(e.UTS);
                        //    result = moment(temp).format("MMM DD, YYYY hh:mm a");
                        //})));
                        var temp = new Date(items[0].UTS);
                        for (var i = 0; i < items.length; i++) {
                            var curDT = new Date(items[i].UTS);
                            if (curDT > temp) {
                                temp = curDT;
                            }
                        }
                        result = moment(temp).format("MMM DD, YYYY hh:mm a");;
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                    return result
                }
            },
            getStatus(data) {
                var status = '';
                if (data.RS == 1) {
                    status = this.getLanguage['BETRPT']['SIP'];
                }
                else if (data.RS == 2) {
                    if (data.IC == 1) {
                        status = this.getLanguage['BETRPT']['SC'];
                    }
                    else if (data.DPS == 0) {
                        status = this.getLanguage['BETRPT']['SPRD'];
                    }
                    else if (data.DPS == 3) {
                        status = this.getLanguage['BETRPT']['SE'];
                    }
                    else {
                        status = this.getLanguage['BETRPT']['SCP'];
                    }
                }

                return status;
            },
            CheckWinLoss(WLA, status, otherAmount) {
                if (WLA != 0) {
                    if (otherAmount >= 0 && status == 2) {
                        return "positive-number";
                    }
                    else if (otherAmount < 0 && status == 2) {
                        return "negative-number";
                    }
                }
            },
            getGameName(name) {
                var tailstr = "";

                if (this.reportType == "AFB1188") {
                    if (name == "PAR") {
                        name = this.reportType + "_" + name;
                    }
                    else {
                        return name;
                    }
                }
                else if (this.reportType == "TFG_ESPORTS") {
                    if (name) {
                        name = name.replace('tfg_combo', this.getLanguage["TFG_ESPORTS"]["COMBO"]);
                    }

                    return name;
                }
                else if (this.reportType == "DIAMONDCLUB") {
                    name = this.reportType + "_" + name;
                }
                else if (this.reportType == "CQ9_LIVE_CASINO") {
                    name = this.reportType + "_" + name;
                }
                else if (this.reportType == "DREAMGAME") {
                    tailstr = name.split("_")[1];
                    name = name.split("_")[0];                    
                }

                var gamename = name;

                if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {
                    gamename = this.getLanguage[this.reportType][name];
                }

                if (this.reportType == "DREAMGAME") {
                    switch (tailstr) {
                        case "10101": gamename = gamename + " " + "DG01"; break;
                        case "10102": gamename = gamename + " " + "DG02"; break;
                        case "10103": gamename = gamename + " " + "DG03"; break;
                        case "10104": gamename = gamename + " " + "DG05"; break;
                        case "10105": gamename = gamename + " " + "DG06"; break;
                        case "10106": gamename = gamename + " " + "DG07"; break;
                        case "10107": gamename = gamename + " " + "DG08"; break;
                        case "10108": gamename = gamename + " " + "DG09"; break;
                        case "10109": gamename = gamename + " " + "DG10"; break;
                        case "10802": gamename = gamename + " " + "DG11"; break;
                        case "10803": gamename = gamename + " " + "DG12"; break;
                        case "10201": gamename = gamename + " " + "DG13"; break;
                        case "10202": gamename = gamename + " " + "DG15"; break;
                        case "10301": gamename = gamename + " " + "DG16"; break;
                        case "10302": gamename = gamename + " " + "DG17"; break;
                        case "10701": gamename = gamename + " " + "DG18"; break;
                        case "11101": gamename = gamename + " " + "DG19"; break;
                        case "11601": gamename = gamename + " " + "DG20"; break;
                        case "10401": gamename = gamename + " " + "DG21"; break;
                        case "10501": gamename = gamename + " " + "DG22"; break;
                        case "30101": gamename = gamename + " " + "CT01"; break;
                        case "30102": gamename = gamename + " " + "CT02"; break;
                        case "30103": gamename = gamename + " " + "CT03"; break;
                        case "30105": gamename = gamename + " " + "CT05"; break;
                        case "30301": gamename = gamename + " " + "CT06"; break;
                        case "30401": gamename = gamename + " " + "CT08"; break;
                        case "30601": gamename = gamename + " " + "CT10"; break;
                        case "50101": gamename = gamename + " " + "E1"; break;
                        case "50102": gamename = gamename + " " + "E3"; break;
                        case "50103": gamename = gamename + " " + "E7"; break;
                        case "50401": gamename = gamename + " " + "R1"; break;
                        case "70101": gamename = gamename + " " + "GC01"; break;
                        case "70102": gamename = gamename + " " + "GC02"; break;
                        case "70103": gamename = gamename + " " + "GC03"; break;
                        case "70105": gamename = gamename + " " + "GC05"; break;
                        case "70106": gamename = gamename + " " + "GC06"; break;
                        case "70501": gamename = gamename + " " + "GC09"; break;
                        case "84101": gamename = gamename + " " + "Q1"; break;
                        case "84102": gamename = gamename + " " + "Q2"; break;
                        case "84103": gamename = gamename + " " + "Q3"; break;
                        case "84104": gamename = gamename + " " + "Q5"; break;
                        case "84105": gamename = gamename + " " + "Q6"; break;
                        case "84106": gamename = gamename + " " + "Q7"; break;
                    }
                }
                return gamename;
            },
            //member all provider report use
            getMemberName() {
                this.memberName = "Member";
                //for (var pt of this.ddMemberList) {
                //    if (pt.id == this.searchUserId) {
                //        this.memberName = pt.label;
                //    }
                //}
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == this.searchUserId) {
                            this.memberName = this.ddMemberList[i].label;
                            break;
                        }
                    }
                }

                //return this.memberName;
            },
            getProviderReport(data) {
                //this.setReportType();
                this.searchGameProviderId = data.GPI;
                this.openMemberWinLossDetail(data);
            },
            getProvName(name) {
                var pname = name;
                pname = this.getLanguage["GP"][name];

                return pname;
            },
            getGN(PN, GN) {
                var result = GN;
                try {
                    result = this.getLanguage[PN][GN];
                    if (result === "") {
                        return GN;
                    }
                    else {
                        return result;
                    }
                }
                catch(e) { }
                //if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {

                //}
                return result;
            },
            //member all provider report use end
            renderGameResult(gameResult, dt, isUrl) {
                if (gameResult && gameResult.length > 0) {
                    if (this.reportType == "AFB1188") {
                        gameResult = gameResult.replace("afb_result", this.getLanguage["WLRPT"]["R"]);
                        gameResult = gameResult.replace("afb_score", this.getLanguage["WLRPT"]["FSC"]);
                        gameResult = gameResult.replace("afb_over", this.getLanguage["AFB1188"]["OV"]);
                        gameResult = gameResult.replace("afb_under", this.getLanguage["AFB1188"]["UN"]);
                        gameResult = gameResult.replace("afb_odd", this.getLanguage["AFB1188"]["ODD"]);
                        gameResult = gameResult.replace("afb_even", this.getLanguage["AFB1188"]["EVEN"]);
                        gameResult = gameResult.replace("afb_draw", this.getLanguage["AFB1188"]["DRAW"]);

                        gameResult = gameResult.replace("afb_win", this.getLanguage["AFB1188"]["WIN"]);

                        gameResult = gameResult.replace(/afb_lastgoal/gi, this.getLanguage["AFB1188"]["LG"]);
                        gameResult = gameResult.replace(/afb_firstgoal/gi, this.getLanguage["AFB1188"]["FG"]);
                        gameResult = gameResult.replace(/afb_nogoal/gi, this.getLanguage["AFB1188"]["NG"]);

                        gameResult = gameResult.replace("afb_dc", this.getLanguage["AFB1188"]["DC"]);
                        gameResult = gameResult.replace("afb_tg", this.getLanguage["AFB1188"]["TG"]);

                        gameResult = gameResult.replace("afb_bd", this.getLanguage["AFB1188"]["BD"]);

                    }
                    else if (this.reportType == "DIAMONDCLUB") {
                        gameResult = gameResult.replace("DRAGONEVEN", this.getLanguage["DIAMONDCLUB"]["DRAGONEVEN"]);
                        gameResult = gameResult.replace("DRAGONODD", this.getLanguage["DIAMONDCLUB"]["DRAGONODD"]);
                        gameResult = gameResult.replace("TIGEREVEN", this.getLanguage["DIAMONDCLUB"]["TIGEREVEN"]);
                        gameResult = gameResult.replace("TIGERODD", this.getLanguage["DIAMONDCLUB"]["TIGERODD"]);
                        gameResult = gameResult.replace("DRAGONBLACK", this.getLanguage["DIAMONDCLUB"]["DRAGONBLACK"]);
                        gameResult = gameResult.replace("DRAGONRED", this.getLanguage["DIAMONDCLUB"]["DRAGONRED"]);
                        gameResult = gameResult.replace("TIGERBLACK", this.getLanguage["DIAMONDCLUB"]["TIGERBLACK"]);
                        gameResult = gameResult.replace("TIGERRED", this.getLanguage["DIAMONDCLUB"]["TIGERRED"]);
                        gameResult = gameResult.replace("DRAGON", this.getLanguage["DIAMONDCLUB"]["DRAGON"]);
                        gameResult = gameResult.replace("TIGER", this.getLanguage["DIAMONDCLUB"]["TIGER"]);

                        gameResult = gameResult.replace("BIG", this.getLanguage["DIAMONDCLUB"]["BIG"]);
                        gameResult = gameResult.replace("SMALL", this.getLanguage["DIAMONDCLUB"]["SMALL"]);
                        gameResult = gameResult.replace("ODD", this.getLanguage["DIAMONDCLUB"]["ODD"]);
                        gameResult = gameResult.replace("EVEN", this.getLanguage["DIAMONDCLUB"]["EVEN"]);
                        gameResult = gameResult.replace("ANYTRIPLE", this.getLanguage["DIAMONDCLUB"]["ANYTRIPLE"]);
                        gameResult = gameResult.replace("EXACT", this.getLanguage["DIAMONDCLUB"]["EXACT"]);

                        gameResult = gameResult.replace("BANKER", this.getLanguage["DIAMONDCLUB"]["BANKER"]);
                        gameResult = gameResult.replace("PLAYER", this.getLanguage["DIAMONDCLUB"]["PLAYER"]);
                        gameResult = gameResult.replace("TIE", this.getLanguage["DIAMONDCLUB"]["TIE"]);
                        gameResult = gameResult.replace("BPAIR", this.getLanguage["DIAMONDCLUB"]["BPAIR"]);
                        gameResult = gameResult.replace("PPAIR", this.getLanguage["DIAMONDCLUB"]["PPAIR"]);

                        gameResult = gameResult.replace("RED", this.getLanguage["DIAMONDCLUB"]["RED"]);
                        gameResult = gameResult.replace("BLACK", this.getLanguage["DIAMONDCLUB"]["BLACK"]);
                    }
                    else if (this.reportType == "CQ9" || this.reportType == "CQ9_FISHING" || (this.reportType == "CQ9_CASINO" && dt && (dt.DT == 1 || isUrl)) || this.reportType == "CQ9_LOTTERY") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "EVOPLAY" || this.reportType == "EVOPLAY_CASINO") {
                        if (dt.DT == 0) {
                            //socket game
                            if (gameResult == "Win" || gameResult == "Lose") {
                                gameResult = gameResult.replace("Win", this.getLanguage["WLRPT"]["RWIN"]);
                                gameResult = gameResult.replace("Lose", this.getLanguage["WLRPT"]["RLOSE"]);
                            } else {
                                gameResult = gameResult;
                            }
                        } else {
                            gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VR"] + '</a>';
                        }

                    }
                    else if (this.reportType == "JOKER" || this.reportType == "JOKER_CASINO") {
                        if (dt.B == 0 && dt.J == 0) {
                            gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        } else {
                            //if (dt.B > 0) gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VBT"] + '</a>';
                            if (dt.B > 0) gameResult = '<span>Grand Jackpot</span>';
                            //if (dt.J > 0) gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VJT"] + '</a>';
                            if (dt.J > 0) gameResult = '<span>Powerbar</span>';
                        }
                    }
                    else if (this.reportType == "PPLAY" || this.reportType == "PPLAY_CASINO" || this.reportType == "PPLAY_E_CASINO") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "PGSOFT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType.match(/betsoft/i)) {
                        if (gameResult == "Win" || gameResult == "Lose") {
                            gameResult = gameResult.replace("Win", this.getLanguage["WLRPT"]["RWIN"]);
                            gameResult = gameResult.replace("Lose", this.getLanguage["WLRPT"]["RLOSE"]);
                        } else {
                            gameResult = '<a href="' + dt.RURL + '" target="_blank">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        }
                    }
                    else if (this.reportType == 'TFG_ESPORTS') {
                        gameResult = gameResult.replace("tfg_result", this.getLanguage["TFG_ESPORTS"]["RE"]);
                        gameResult = gameResult.replace("tfg_over", this.getLanguage["TFG_ESPORTS"]["OV"]);
                        gameResult = gameResult.replace("tfg_under", this.getLanguage["TFG_ESPORTS"]["UN"]);
                        gameResult = gameResult.replace("tfg_draw", this.getLanguage["TFG_ESPORTS"]["DRAW"]);
                    }
                    else if (this.reportType == 'CONNECT93') {
                        gameResult = gameResult.replace("GN", 'GameName');
                        gameResult = gameResult.replace("DN", 'Periods');
                        gameResult = gameResult.replace("BT", 'BetConent');
                        gameResult = gameResult.replace("BO", 'Odds');
                        gameResult = gameResult.replace("GRS", 'TotalSum');
                    }
                    else if (this.reportType == "AFBGAMING") {// || this.reportType == "AFBGAMING_FISHING"
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "AFBGAMING_FISHING") {
                        //gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>'; //pending afbgaming develop
                        //gameResult = '<span>' + gameResult + '</span>';
                    }
                    else if (this.reportType == "LUCKY361_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType.match(/habanero/i)) {
                        gameResult = '<a href="' + dt.RURL + '" target="_blank">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SPINOMENAL_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SPINOMENAL_LOTTERY") {
                        // gameResult = '<a href="' + dt.RURL + '" target="_blank">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "NETENT" || this.reportType == "REDTIGER") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "SIMPLEPLAY_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "JDB_FISHING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "JDB_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "BOOMING_GAMES") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "KA_FISHING") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "KA_SLOT") {
                        gameResult = '<a href="#">' + this.getLanguage["WLRPT"]["VT"] + '</a>';
                    }
                    else if (this.reportType == "LG88") {

                    }
                    else if (this.reportType == "YGGDRASIL" || this.reportType == "YGGDRASIL_E_CASINO") {

                    }
                    else if (this.reportType == "PNG_SLOT") {

                    }
                    else if (this.reportType == "AUX_SLOT") {

                    }
                    else if (this.reportType == "GHG_SLOT") {

                    }
                    else if (this.reportType == "NLC_SLOT") {

                    } else if (this.reportType == "RELAX_SLOT") {

                    }
                    else if (this.reportType == "RELAX_E_CASINO") {

                    }
                    else if (this.reportType == "ATA_EVOPLAY_SLOT") {

                    }
                    else if (this.reportType == "AIS_SLOTS") {
                        //gameResult = `<a href="${dt.GR}" target="_blank">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "JILI_SLOT") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "JILI_FISHING") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                    else if (this.reportType == "EBET_SLOT") {
                        gameResult = `<a href="#">${this.getLanguage["WLRPT"]["VT"]}</a>`;
                    }
                }
                else {
                    if (this.reportType == "CQ9" || this.reportType == "CQ9_FISHING" || this.reportType == "CQ9_CASINO" || this.reportType == "CQ9_LOTTERY") {
                        try {
                            if (dt.GN == "promo_payoff") {
                                var realGn = this.getGameName(dt.GN);
                                gameResult = "<span>"+ realGn +"</span>"
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                }
                return gameResult;
            },
            gameResultOnClick(dt) {               
                if ((this.reportType == "CQ9" || this.reportType == "CQ9_FISHING" || (this.reportType == "CQ9_CASINO" && dt.DT == 1) || this.reportType == "CQ9_LOTTERY" || this.reportType == "CQ9_LIVE_CASINO") && dt && dt.GR) {
                    this.openCQ9Details(dt);
                }
                else if ((this.reportType == "EVOPLAY" || this.reportType == "EVOPLAY_CASINO") && dt && dt.GR && dt.DT == 1) {
                    this.openEvoPlayDetails(dt);
                }
                else if ((this.reportType == "JOKER" || this.reportType == "JOKER_CASINO") && dt && dt.GR) {
                    this.openJokerDetails(dt);
                }
                else if ((this.reportType == "PPLAY" || this.reportType == "PPLAY_CASINO" || this.reportType == "PPLAY_E_CASINO") && dt && dt.GR) {
                    this.openPPlayDetails(dt);
                }
                else if (this.reportType == "PGSOFT" && dt && dt.GR) {
                    this.PGgameResult(dt.TI, dt.TI, dt.GN);
                }
                //else if ((this.reportType == "AFBGAMING" || this.reportType == "AFBGAMING_FISHING") && dt && dt.GR) {
                else if (this.reportType == "AFBGAMING" && dt && dt.GR){
                    this.openAFBGamingDetails(dt);
                }
                else if (this.reportType == "LUCKY361_SLOT" && dt && dt.GR) {
                    this.openLUCKY361Details(dt);
                }
                else if (this.reportType == "SPINOMENAL_SLOT" && dt && dt.GR) {
                    this.openSpinomenalDetails(dt.SPINOMENALCHILD[0]);
                }
                else if (this.reportType == "SPINOMENAL_LOTTERY" && dt && dt.GR) {
                    this.openSpinomenalDetails(dt.SPINOMENALCHILD[0]);
                }
                else if (this.reportType == "SIMPLEPLAY_SLOT" && dt && dt.GR) {
                    this.openSimplePlayDetails(dt);
                }
                else if ((this.reportType == "REDTIGER" || this.reportType == "NETENT") && dt && dt.GR) {
                    this.openBetPlayDetails(dt);
                }
                else if (this.reportType == "JDB_FISHING" && dt && dt.GR) {
                    this.openJDBFishingDetails(dt);
                }
                else if (this.reportType == "JDB_SLOT" && dt && dt.GR) {
                    this.openJDBSlotDetails(dt);
                }
                else if (this.reportType == "BOOMING_GAMES" && dt && dt.GR) {
                    this.openBoomingGamesDetails(dt);
                }
                else if (this.reportType == "KA_FISHING" && dt && dt.GR) {
                    this.openKAFishingDetails(dt);
                }
                else if (this.reportType == "KA_SLOT" && dt && dt.GR) {
                    this.openKASlotDetails(dt);
                }
                else if ((this.reportType == "JILI_SLOT" || this.reportType == "JILI_FISHING") && dt && dt.GR) {
                    this.openJILIDetails(dt);
                }
                else if ((this.reportType == "EBET_SLOT") && dt && dt.GR) {
                    this.openEBETDetails(dt);
                }
                return false;
            },
            gameResultDetailOnClick(dt) {
                if (this.reportType == "CQ9_CASINO" && dt.DT == 0 && dt && dt.RURL) {
                    this.openCQ9Details(dt);
                } else if ((this.reportType == "RELAX_SLOT" || this.reportType == "RELAX_E_CASINO")) {
                    this.openRELAXDetails(dt)
                }

                return false;
            },
            getWe1LastTotalPayment(data, getCSSClass = false) {
                var result = '';
                try {
                    //this.formatNumber(data.BCWLA, data.ISOC);
                    var tempLTP = 0;
                    tempLTP = data.WLA + data.AWL;
                    if (getCSSClass) {
                        if (tempLTP >= 0) {
                            result = "positive-number";
                        }
                        else {
                            result = "negative-number";
                        }
                    }
                    else {
                        result = this.formatNumber(tempLTP, data.ISOC);
                    }
                } catch (error) {
                    console.log(error);
                }
                return result;
            },
            renderAFBWL(res) {
                if (res != "") {
                    let color = "black";
                    switch (res) {
                        case "WA":
                        case "WH":
                            color = "green";
                            break;
                        case "LA":
                        case "LH":
                            color = "red";
                            break;
                    }
                    return `<div style="color: ${color}">${this.getLanguage["WLRPT"]["R" + res]}</div>`;
                }
                return res;
            },
            renderSBOWL(cbd) {
                if (cbd != "") {
                    let color = "black";
                    switch (cbd) {
                        case "won": case "won1":
                            color = "green";
                            cbd = cbd == "won" ? "Won" : "Half Won";
                            break;
                        case "lose": case "lose1":
                            color = "red";
                            cbd = cbd == "lose" ? "Lose" : "Half Lose";
                            break;
                    }

                    return `<div style="color: ${color}">${cbd}</div>`;
                }
                return cbd;
            },
            renderGD88WL(res) {
                if (res != "")
                    return this.getLanguage["WLRPT"]["R" + res];

                return res;
            },
            openCQ9Details(dt) {
                var that = this;
                var param = dt.RURL ? dt.RURL : dt.GR;

                if (that.getLangCode == 'cn') {
                    param += "&lang=zh-cn";
                } else {
                    param += `&lang=en`;
                }

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/cq9/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'cq9result');
                        }
                    });
            },
            openRELAXDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                let url= btoa(dt.N)
                this.getDataApi(`/api/reports/winloss/relax/detail?playback=${url}`,
                    function (playback) {
                        that.bool_fullLoading = false;
                        if (playback) {
                            window.open(playback);
                        }
                    });
            },
            openEvoPlayDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/evoplay/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'evoplayresult');
                        }
                    });
            },
            openJokerDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/joker/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'jokerresult');
                        }
                    });
            },
            openPPlayDetails(dt) {
                var that = this;

                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/pplay/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'pplayresult');
                        }
                    });
            },
            openAFBGamingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                var param = `gpi=${dt.GPI}&agi=${dt.AGI}&betId=${dt.TI}`;
                this.getDataApi(`/api/reports/winloss/afbgaming/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'afbgamingresult');
                            //window.open(d, 'afbgaming');
                        }
                    });
            },
            openLUCKY361Details(dt) {
                var that = this;
                that.bool_fullLoading = true;
                var param = `gpi=${dt.GPI}&agi=${dt.AGI}&betId=${dt.TI}`;
                this.getDataApi(`/api/reports/winloss/lucky361/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'lucky361result');
                            //window.open(d, 'afbgaming');
                        }
                    });
            },

            openSpinomenalDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/spinomenal/detail?TI=${dt.TI}&MGBTI=${dt.MGBTI}&U=${dt.U}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d, 'spinomenalresult');
                        }
                    });
            },
            openSimplePlayDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/simpleplay/detail?GI=${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d && d.D) {
                            window.open(d.D, 'simpleplayresult');
                        }
                    });
            },
            openBetPlayDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/reports/winloss/betplay/detail?${dt.GR}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'betplayresult');
                        }
                    });
            },
            openJDBFishingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/jdbfishing/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'jdbresult');
                        }
                    });
            },
            openJDBSlotDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/jdbslot/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'jdbresult');
                        }
                    });
            },
            openBoomingGamesDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/boominggames/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'boominggamesresult');
                        }
                    });
            },
            openKAFishingDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/kafishing/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'karesult');
                        }
                    });
            },
            openKASlotDetails(dt) {
                var that = this;
                that.bool_fullLoading = false;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/kaslot/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'karesult');
                        }
                    });
            },
            openLG88Details(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = dt.GR;
                param += "&lang=" + that.getLangCode;

                this.getDataApi(`/api/reports/winloss/lg88/detail?${param}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d) {
                            window.open(d.D, 'lg88result');
                        }
                    });
            },
            openJILIDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;

                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/jili/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'jiliresult');
                        }
                    });
            },
            openEBETDetails(dt) {
                var that = this;
                that.bool_fullLoading = true;
                //debugger;
                var param = `${dt.GR}&lang=${that.getLangCode}`;
                this.getDataApi(`/api/reports/winloss/ebet/detail?${param}`,
                    function (d, s) {
                        if (s && d) {
                            that.bool_fullLoading = false;
                            window.open(d.D, 'ebetresult');
                        }
                    });
            },
            getReportURL() {
                //debugger;
                var url = '/api/reports/winloss';
                switch (this.reportType) {
                    case "MemberSummary":
                        url += '/allv2';  //added BCBA, BCWLA

                        break;
                    case "N2":
                        url += '/n2'; //added BCBA, BCWLA
                        break;
                    case "PS":
                        url += "/ps"; //PLAYSTAR SLOTS added BCBA, BCWLA
                        break;
                    case "PGSOFT":
                        url += "/pgsoft"; //added BCBA, BCWLA
                        break;
                    case "SA":
                        url += "/sa";   //added BCBA, BCWLA
                        break;
                    case "AFBCASINO":
                        url += "/tga"; //added BCBA, BCWLA
                        break;
                    case "LIGATOGEL":
                        url += "/ligatogel";   //added BCBA, BCWLA
                        break;
                    case "AFB288_LOTTERY":
                        url += "/afb288";   //added BCBA, BCWLA
                        break;
                    case "DIAMONDCLUB":
                        url += '/gd88'; //added BCBA, BCWLA
                        break;
                    case "AFB1188":
                        url += '/afb1188'; //added BCBA, BCWLA
                        break;
                    case "summary":
                        url += "/summary";  //added BCBA, BCWLA
                        break;
                    case "CQ9":
                    case "CQ9_CASINO":
                    case "CQ9_FISHING":
                    case "CQ9_LOTTERY":
                    case "CQ9_LIVE_CASINO":
                        url += "/cq9"; //added BCBA, BCWLA
                        break;
                    case "EVOPLAY":
                    case "EVOPLAY_CASINO":
                        url += "/evoplay";  //added BCBA, BCWLA
                        break;
                    case "JOKER":
                    case "JOKER_CASINO":
                        url += "/joker";     //added BCBA, BCWLA
                        break;
                    case "BETSOFT":
                    case "BETSOFT_CASINO":
                    case "BETSOFT_POKER":
                        url += "/betsoft"; //added BCBA, BCWLA
                        break;
                    case "PPLAY":
                    case "PPLAY_CASINO":
                    case "PPLAY_E_CASINO":
                        url += "/pplay"; //added BCBA, BCWLA
                        break;
                    case "WM":
                        url += "/wm"    //added BCBA, BCWLA
                        break;
                    case "TFG_ESPORTS":
                        url += '/tfg'; //added BCBA, BCWLA
                        break;
                    case "TTG":
                        url += '/ttg';  //added BCBA, BCWLA
                        break;
                    case "CONNECT93":
                        url += '/93connect';    //added BCBA, BCWLA
                        break;
                    case "AESEXY":
                        url += '/aesexy';   //added BCBA, BCWLA
                        break;
                    case "SV388":
                        url += '/sv388';    //added BCBA, BCWLA
                        break;
                    case "CF361":
                        url += '/cf361';    //added BCBA, BCWLA
                        break;
                    case "DREAMGAME":
                        url += '/dg';    //added BCBA, BCWLA
                        break;
                    case "AFBGAMING":
                    case "AFBGAMING_FISHING":
                        url += '/afbgaming';    //added BCBA, BCWLA but SP is showing error, already had a ticket for this. --TT3210
                        break;
                    case "LUCKY361_SLOT":
                        url += '/lucky361';
                        break;
                    case "HABANERO":
                        url += '/habanero'; //added BCBA, BCWLA
                        break;
                    case "EACASINO":
                        url += '/eacasino'; //added BCBA, BCWLA
                        break;
                    case "SPINOMENAL_SLOT":
                    case "SPINOMENAL_LOTTERY":
                        url += "/spinomenal";   //added BCBA, BCWLA
                        break;
                    case "WE1POKER":
                        url += '/we1poker';     //added BCBA, BCWLA
                        break;
                    case "NETENT":
                    case "REDTIGER":
                    case "EVOLUTION_CASINO":
                        url += '/betplay';   //added BCBA, BCWLA
                        break;
                    case "SIMPLEPLAY_SLOT":
                    case "SIMPLEPLAY_FISHING":
                        url += '/simpleplay'; //added BCBA, BCWLA
                        break;
                    case "EBET":
                    case "EBET_SLOT":
                        url += '/ebet'; //added BCBA, BCWLA
                        break;
                    case "CG":
                    case "CG_FISHING":
                    case "CG_VIRTUAL_CASINO":
                    case "CG_E_CASINO":
                        url += '/cg';       //added BCBA, BCWLA
                        break;
                    case "JDB_FISHING":
                        url += '/jdb_fishing';      //added BCBA, BCWLA
                        break;
                    case "JDB_SLOT":
                        url += '/jdb_slot';      //added BCBA, BCWLA
                        break;
                    case "BOOMING_GAMES":
                        url += '/boominggames';      //added BCBA, BCWLA
                        break;
                    case "KA_FISHING":
                        url += '/ka_fishing';   //added BCBA, BCWLA
                        break;
                    case "KA_SLOT":
                        url += '/ka_slot';   //added BCBA, BCWLA
                        break;
                    case "POKERV":
                        url += '/pkv';  //added BCBA, BCWLA
                        break;
                    case "LG88":
                        url += '/lg88'; //added BCBA, BCWLA
                        break;
                    case "YGGDRASIL":
                    case "YGGDRASIL_E_CASINO":
                        url += '/yggdrasil';    //added BCBA, BCWLA
                        break;
                    case "PNG_SLOT":
                        url += '/png_slot';     //added BCBA, BCWLA
                        break;
                    case "AUX_SLOT":
                        url += '/aux_slot';     //added BCBA, BCWLA
                        break;
                    case "GHG_SLOT":
                        url += '/ghg_slot';     //added BCBA, BCWLA
                        break;
                    case "NLC_SLOT":
                        url += '/nlc_slot';     //added BCBA, BCWLA
                        break;
                    case "RELAX_SLOT":
                    case "RELAX_E_CASINO":
                        url += '/relax';     //added BCBA, BCWLA
                        break;
                    case "AIS_SLOTS":
                        url += '/ais';    //added IsTestUser
                        break;
                    case "JILI_SLOT":
                    case "JILI_FISHING":
                        url += '/jili';    //added IsTestUser
                        break;
                    case "EVO_RACING":
                        url += '/evoracing';    //added IsTestUser
                        break;
                    case "EVO_RACING_VR":
                        url += '/evoracingvr';    //added IsTestUser
                        break;
                    case "ATA_EVOPLAY_SLOT":
                        url += '/ata_evoplay_slot';
                        break;
                    case "SBO_SPORTSBOOK":
                        url += '/sbo_sportsbook';
                        break;
                }

                return url;
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            //selectMemberOptions(node, instanceId) {
            //    // this.searchAgi = node.agi;
            //    this.setReportType();
            //},
            //deSelectMemberOptions(node, instanceId) {
            //    this.setReportType();
            //    this.searchUserId = null;
            //    this.searchUsername = null;
            //},
            openMemberWinLossDetail(data) {
                //debugger
                this.ddDefaultMemberList = [
                    { id: data.MI, label: data.U }
                ];

                this.dd_memberKey++;

                this.searchUserId = data.MI;
                this.searchUsername = data.U;
                this.searchCurrency = data.CI;
                this.setReportType();
                this.getReportList();
            },
            clickList(data, index, GameResult) {
                if (this.reportType == "AFB1188") {
                    if (data.GN == "PAR" || data.GN == "PAM")
                        data.bool_showDetails = !data.bool_showDetails;
                }
                else if (this.reportType == "EVOPLAY_CASINO") {
                    if (data.DT == 0)
                        var path = "p=" + data.GPI + "&agi=" + data.AGI + "&tradeid=" + data.TI;
                    this.getDataApi(`/api/reports/winloss/evoplay/betdetail?${path}`,
                        function (d, s) {
                            if (s && d && d) {
                                data.BTDESCR = d;
                                data.bool_showDetails = !data.bool_showDetails;
                            }
                        });
                }
                else if (this.reportType == "PGSOFT") {
                    if (data.PGSOFTCHILD.length > 1) {
                        data.bool_showDetails = !data.bool_showDetails;
                    }
                }
                else {
                    data.bool_showDetails = !data.bool_showDetails;
                }
                this.resizeTableHead();
            },
            getProviderName() {
                if (this.reportType in this.getLanguage["GP"]) {
                    return this.getLanguage["GP"][this.reportType];
                }

                return this.reportType;
            },
            gameNameColspan() {
                if (this.reportType == "PS")
                    return 1;

                return 2;
            },
            gameResultColspan() {
                if (this.reportType == "PS" || this.reportType == "PGSOFT")
                    return 1;

                return 2;
            },

            withBonus() {
                if (
                    //this.reportType == "PS" ||
                    this.reportType == "JOKER" ||
                    this.reportType == "JOKER_CASINO")
                    return true;

                return false;
            },
            withJackpot() {
                if (
                    //this.reportType == "PS" ||
                    this.reportType == "CQ9" ||
                    this.reportType == "PPLAY" ||
                    this.reportType == "PPLAY_CASINO" ||
                    this.reportType == "PPLAY_E_CASINO" ||
                    this.reportType == "PGSOFT" ||
                    this.reportType == "JOKER" ||
                    this.reportType == "JOKER_CASINO")
                    return true;

                return false;
            },
            withWE1POKER() {
                if (this.searchGameProviderId == 43 || this.searchGameProviderId == 55)
                    return true;
                return false;
            },
            formatPT2(data) {
                var result = '';
                switch (this.getUserInfo.AT) {
                    case 0:
                        var PLA = 100 - this.formatNumber(data.WLS) - this.formatNumber(data.SAWLS) - this.formatNumber(data.MAWLS) - this.formatNumber(data.AWLS);

                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(PLA) +
                                "/" + this.formatNumber(data.WLS) +
                                "/" + this.formatNumber(data.SAWLS) +
                                "/" + this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }

                        this.shareIndicator = this.getLanguage['WLRPT']['PRV'] +
                            "/" + this.getLanguage['WLRPT']['CO'] +
                            "/" + this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 1:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.SAWLS) +
                                "/" + this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 2:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.MAWLS) +
                                "/" + this.formatNumber(data.AWLS);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 3:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.AWLS);

                        }
                        this.shareIndicator = this.getLanguage['WLRPT']['AG'];
                        break;
                }

                return result;
            },
            formatPT(data) {
                if (data.ADPT == 0)
                    return this.formatPT2(data);
                var result = '';
                if (data.SSADPT < 2) {
                    data.PPT = data.PPT + data.SSADPT - 2;
                    data.SSADPT = 2;
                }
                switch (this.getUserInfo.AT) {
                    case 0:
                        //var PLA = 100 - this.formatNumber(data.WLS) - this.formatNumber(data.SAWLS) - this.formatNumber(data.MAWLS) - this.formatNumber(data.AWLS);

                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.PPT) +
                                "/" + this.formatNumber(data.SSADPT) +
                                "/" + this.formatNumber(data.SADPT) +
                                "/" + this.formatNumber(data.MADPT) +
                                "/" + this.formatNumber(data.ADPT);
                        }

                        this.shareIndicator = this.getLanguage['WLRPT']['PRV'] +
                            "/" + this.getLanguage['WLRPT']['CO'] +
                            "/" + this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 1:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.SADPT) +
                                "/" + this.formatNumber(data.MADPT) +
                                "/" + this.formatNumber(data.ADPT);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['SAG'] +
                            "/" + this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 2:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.MADPT) +
                                "/" + this.formatNumber(data.ADPT);
                        }


                        this.shareIndicator = this.getLanguage['WLRPT']['MAG'] +
                            "/" + this.getLanguage['WLRPT']['AG'];

                        break;
                    case 3:
                        if (data.PTPS == 0) {
                            result = this.getLanguage['WLRPT']['PPTP'];
                        }
                        else {
                            result = this.formatNumber(data.ADPT);

                        }
                        this.shareIndicator = this.getLanguage['WLRPT']['AG'];
                        break;
                }

                return result;
            },
            PGgameResult(pti, ti, gi) {
                this.getDataApi(`/api/reports/winloss/pgsoft/r?PID=${pti}&CID=${ti}&gameId=${gi}`, function (d, s) {
                    if (s) {
                        window.open(d, '_blank');
                    }
                });

            },
            displayGameResult(value, recStatus) {
                if (recStatus != 1) return value;
                else return "NA";
            },
            displayExchangeRate(value) {
                return (value / 10000).toFixed(4);
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getTodayDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            lg88RenderDetail(gameResult) {
                try {
                    var gameResultObject = JSON.parse(gameResult);

                    var result = "";
                    var betContentResult = "Bet Content:";
                    if (gameResultObject["GR"]["round_details"]["banker"] != undefined) {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["BACCARAT"] + "<br />";
                        result += this.getLanguage["LG88"]["BANKER"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["banker"]) + "<br />";
                        result += this.getLanguage["LG88"]["PLAYER"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["player"]);
                        betContentResult += this.lg88RenderBetContent(0, gameResultObject["BT"]);
                    }
                    else if (gameResultObject["GR"]["round_details"]["dragon"] != undefined) {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["DRAGONTIGER"] + "<br />";
                        result += this.getLanguage["LG88"]["DRAGON"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["dragon"]) + "<br />";
                        result += this.getLanguage["LG88"]["TIGER"] + ":" + this.lg88RenderPorker(gameResultObject["GR"]["round_details"]["tiger"]);
                        betContentResult += this.lg88RenderBetContent(1, gameResultObject["BT"]);
                    }
                    else if (gameResultObject["GR"]["round_details"]["n"] != undefined) {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["ROULETTE"] + "<br />";
                        result += gameResultObject["GR"]["round_details"]["n"];
                        betContentResult += this.lg88RenderBetContent(2, gameResultObject["BT"]);
                    }
                    else {
                        result += this.getLanguage["BETRPT"]["G"] + ":" + this.getLanguage["LG88"]["SICBO"] + "<br />";
                        result += this.lg88RenderSicbo(gameResultObject["GR"]["round_details"]);
                        betContentResult += this.lg88RenderBetContent(3, gameResultObject["BT"]);
                    }

                    return result + "<br />" + betContentResult;
                }
                catch (e) { return ""; }
            },
            lg88RenderPorker(numstring) {
                var numstringArray = numstring.split('*');
                var result = "";
                for (var i = 0; i < numstringArray.length; i++) {
                    var num = parseInt(numstringArray[i])
                    switch ((num / 13) && + (num / 13) | 0 || 0) {
                        case 0:
                            result += "<img src=\"/Content/img/spade.png\" class=\"gr-icon\">";
                            break;
                        case 1:
                            result += "<img src=\"/Content/img/heart.png\" class=\"gr-icon\">";
                            break;
                        case 2:
                            result += "<img src=\"/Content/img/club.png\" class=\"gr-icon\">";
                            break;
                        case 3:
                            result += "<img src=\"/Content/img/diamond.png\" class=\"gr-icon\">";
                            break;
                    }
                    switch ((num % 13) && + (num % 13) | 0 || 0) {
                        case 0:
                            result += "A";
                            break;
                        case 10:
                            result += "J";
                            break;
                        case 11:
                            result += "Q";
                            break;
                        case 12:
                            result += "K";
                            break;
                        default:
                            result += ((num % 13) && + (num % 13) | 0 || 0) + 1;
                    }
                }
                return result;
            },
            lg88RenderSicbo(numArray) {
                var result = "";
                for (var i = 0; i < numArray.length; i++) {
                    result += "<img src=\"/Content/img/dice-" + numArray[i] + ".png\" class=\"gr-fishing\">";
                }
                return result;
            },
            lg88RenderBetContent(type, contentArray) {
                var contentFormat;
                var result = "";
                switch (type) {
                    case 0:
                        contentFormat = ["Banker", "Tie", "Player", "Small", "Big", "Banker Pair", "Player Pair", "Banker Pair of no commission"];
                        break;
                    case 1:
                        contentFormat = ["Dragon", "Tie", "Tiger", "Dragon Odd", "Dragon Even", "Dragon Red", "Dragon Black", "Tiger Odd", "Tiger Even", "Tiger Red", "Tiger Black"];
                        break;
                    case 2:
                        contentFormat = ["Red", "Black", "Odd", "Event", "Small", "Big", "Dozen[1-12]", "Dozen[13-24]", "Dozen[25-36]", "Column[1,4,7,10,13,16,19,22,25,28,31,34]", "Column[2,5,8,11,14,17,20,23,26,29,32,35]", "Column[3,6,9,12,15,18,21,24,27,30,33,36]", "Line[1-6]", "Line[4-9]", "Line[7-12]", "Line[10-15]", "Line[13-18]", "Line[16-21]", "Line[19-24]", "Line[22-27]", "Line[25-30]", "Line[28-33]", "Line[31-36]", "Corner[1,2,4,5]", "Corner[2,3,5,6]", "Corner[4,5,7,8]", "Corner[5,6,8,9]", "Corner[7,8,10,11]", "Corner[8,9,11,12]", "Corner[10,11,13,14]", "Corner[11,12,14,15]", "Corner[13,14,16,17]", "Corner[14,15,17,18]", "Corner[16,17,19,20]", "Corner[17,18,20,21]", "Corner[19,20,22,23]", "Corner[20,21,23,24]", "Corner[22,23,25,26]", "Corner[23,24,26,27]", "Corner[25,26,28,29]", "Corner[26,27,29,30]", "Corner[28,29,31,32]", "Corner[29,30,32,33]", "Corner[31,32,34,35]", "Corner[32,33,35,36]", "Number[0,1,2,3]", "Street[1,2,3]", "Street[4,5,6]", "Street[7,8,9]", "Street[10,11,12]", "Street[13,14,15]", "Street[16,17,18]", "Street[19,20,21]", "Street[22,23,24]", "Street[25,26,27]", "Street[28,29,30]", "Street[31,32,33]", "Street[34,35,36]", "Street[0,1,2]", "Street[0,2,3]", "Split 2 Number[0,1]", "Split 2 Number[0,2]", "Split 2 Number[0,3]", "Split 2 Number[1,2]", "Split 2 Number[2,3]", "Split 2 Number[1,4]", "Split 2 Number[2,5]", "Split 2 Number[3,6]", "Split 2 Number[4,5]", "Split 2 Number[5,6]", "Split 2 Number[4,7]", "Split 2 Number[5,8]", "Split 2 Number[6,9]", "Split 2 Number[7,8]", "Split 2 Number[8,9]", "Split 2 Number[7,10]", "Split 2 Number[8,11]", "Split 2 Number[9,12]", "Split 2 Number[10,11]", "Split 2 Number[11,12]", "Split 2 Number[10,13]", "Split 2 Number[11,14]", "Split 2 Number[12,15]", "Split 2 Number[13,14]", "Split 2 Number[14,15]", "Split 2 Number[13,16]", "Split 2 Number[14,17]", "Split 2 Number[15,18]", "Split 2 Number[16,17]", "Split 2 Number[17,18]", "Split 2 Number[16,19]", "Split 2 Number[17,20]", "Split 2 Number[18,21]", "Split 2 Number[19,20]", "Split 2 Number[20,21]", "Split 2 Number[19,22]", "Split 2 Number[20,23]", "Split 2 Number[21,24]", "Split 2 Number[22,23]", "Split 2 Number[23,24]", "Split 2 Number[22,25]", "Split 2 Number[23,26]", "Split 2 Number[24,27]", "Split 2 Number[25,26]", "Split 2 Number[26,27]", "Split 2 Number[25,28]", "Split 2 Number[26,29]", "Split 2 Number[27,30]", "Split 2 Number[28,29]", "Split 2 Number[29,30]", "Split 2 Number[28,31]", "Split 2 Number[29,32]", "Split 2 Number[30,33]", "Split 2 Number[31,32]", "Split 2 Number[32,33]", "Split 2 Number[31,34]", "Split 2 Number[32,35]", "Split 2 Number[33,36]", "Split 2 Number[34,35]", "Split 2 Number[35,36]", "Number 0", "Number 1", "Number 2", "Number 3", "Number 4", "Number 5", "Number 6", "Number 7", "Number 8", "Number 9", "Number 10", "Number 11", "Number 12", "Number 13", "Number 14", "Number 15", "Number 16", "Number 17", "Number 18", "Number 19", "Number 20", "Number 21", "Number 22", "Number 23", "Number 24", "Number 25", "Number 26", "Number 27", "Number 28", "Number 29", "Number 30", "Number 31", "Number 32", "Number 33 ", "Number 34 ", "Number 35", "Number 36"];
                        break;
                    case 3:
                        contentFormat = ["Big", "Small", "Odd", "Even", "Any Triple", "Triple 1", "Triple 2", "Triple 3", "Triple 4", "Triple 5", "Triple 6", "Dice 1", "Dice 2", "Dice 3", "Dice 4", "Dice 5", "Dice 6", "Pair 1", "Pair 2", "Pair 3", "Pair 4", "Pair 5", "Pair 6", "1 and 2", "1 and 3", "1 and 4", "1 and 5", "1 and 6", "2 and 3", "2 and 4", "2 and 5", "2 and 6", "3 and 4", "3 and 5", "3 and 6", "4 and 5", "4 and 6", "5 and 6", "Total Point 4", "Total Point 17", "Total Point 5", "Total Point 16", "Total Point 6", "Total Point 15", "Total Point 7", "Total Point 14", "Total Point 8", "Total Point 13", "Total Point 9", "Total Point 10", "Total Point 11", "Total Point > 12"];
                        break;
                }

                for (var i = 0; i < contentArray.length; i++) {
                    result += "<br />" + contentFormat[contentArray[i]["type"] - 1] + " (Amount:" + contentArray[i]["value"] + ")";
                }

                return result;
            },
            generateEndTime(RS, CTS, RTS) {
                var result = "";
                try {
                    if (RS == 2) {
                        if (CTS > RTS) {
                            result = this.formatDateTime(CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) + "*";
                        }
                        else {
                            result = this.formatDateTime(RTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true);
                        }

                    }
                    else {
                        result = "N/A";
                    }
                }
                catch (e) {
                    console.log(e);
                }
                return result;
            },
            getMemberTypeList() {
                this.dd_userType = [{ id: '1', label: this.getLanguage['MEM']['NMEM'] }, { id: '2', label: this.getLanguage['MEM']['TMEM'] }];
            },
            getSummaryHeader(header) {
                if (header != null && header != "") {
                    if (this.memberName != null) {
                        header = header.replace("{{uid}}", this.memberName);
                        console.log(header);
                    }
                    else {
                        header = header.replace("{{uid}}", "");
                    }
                    if (this.searchCreatedTS != null) {
                        var startDate = this.searchCreatedTS.startDate.toISOString().replace("T", "").replace("Z", "");
                        var endDate = this.searchCreatedTS.endDate.toISOString().replace("T", "").replace("Z", "");
                        var temp = this.formatDateTime(startDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true)
                            + " - "
                            + this.formatDateTime(endDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true);
                        header = header.replace("{{time}}",temp);
                    }
                }

                return header;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS3';
            this.$parent.showActiveMenu = 'R.WINL';
            this.hideBrand = this.getUserInfo.IHAGIF;

            this.searchUserId = this.$route.query.i;
            this.searchUserType = this.$route.query.ut;
            this.searchUsername = this.$route.query.u;
            this.searchAgi = this.$route.query.agi;

            if (this.$route.query.gpi) {
                this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);
            }
            if ((this.searchUserType) && (this.searchUserType > 0)) {
                this.searchIsTester = this.searchUserType;
            }
            if (this.searchAgi > 0) {
                this.searchAgent = '3-' + this.searchAgi;
            }
            if (this.$route.query.df) {
                this.searchCreatedTS.startDate = this.$route.query.df;
                sessionStorage.setItem('FilterStartDate', this.$route.query.df);
            } else {
                var startDate = sessionStorage.getItem('FilterStartDate');
                if (startDate) {
                    this.searchCreatedTS.startDate = startDate;
                    sessionStorage.removeItem('FilterStartDate');
                }
            }
            if (this.$route.query.dt) {
                this.searchCreatedTS.endDate = this.$route.query.dt;
                sessionStorage.setItem('FilterEndDate', this.$route.query.dt);
            } else {
                var endDate = sessionStorage.getItem('FilterEndDate');
                if (endDate) {
                    this.searchCreatedTS.endDate = endDate;
                    sessionStorage.removeItem('FilterEndDate');
                }
            }
            if (this.searchUserId && this.searchUsername) {
                this.setReportType();

                this.ddDefaultMemberList = [
                    { id: this.searchUserId, label: this.searchUsername }
                ];
            }

            if (this.$route.query.as == 't') {
                var that = this;
                window.setTimeout(function () {
                    that.setReportType();
                    that.getReportList();
                }, 1000);
            }
            this.getMemberTypeList();
        }
        
    }
</script>
<style>
    .scrollHide {
        overflow-y: unset !important;
        overflow-x: scroll !important;
    }
 </style >



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/WinLoss.vue